"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "More options": "Mais opções",
  "Press enter to explore {overflowItems} more actions.": ["Pressione Enter para ver mais ", ["overflowItems"], " ações."]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map